export const ROUTES_BLANK = "/";
export const ROUTES_STATION = "stations";
export const ROUTES_ORGANIZATION = "organizations";
export const ROUTES_PROJECTS = "projects";
export const ROUTES_STATIONTYPES = "station-types";
export const ROUTES_ONBOARDINGSERVICES = "onboarding-services";